import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ComingSoonPage from "../components/ComingSoonPage";

export default function HomeHubPage() {
  return (
    <ComingSoonPage
      title="Home Coming Soon"
      message="This feature is currently under development and will be available in a future release."
      icon={<HomeOutlinedIcon sx={{ fontSize: 32, color: "#005BF0" }} />}
    />
  );
}
